export default __webpack_public_path__ + "static/media/window.3e418c5c.svg";